import { render, staticRenderFns } from "./changeReceivingAccount.vue?vue&type=template&id=3b794b2e&scoped=true&"
import script from "./changeReceivingAccount.vue?vue&type=script&lang=js&"
export * from "./changeReceivingAccount.vue?vue&type=script&lang=js&"
import style0 from "./changeReceivingAccount.vue?vue&type=style&index=0&id=3b794b2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b794b2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3b794b2e', component.options)
    } else {
      api.reload('3b794b2e', component.options)
    }
    module.hot.accept("./changeReceivingAccount.vue?vue&type=template&id=3b794b2e&scoped=true&", function () {
      api.rerender('3b794b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/changeReceivingAccount.vue"
export default component.exports